import React from "react";
import * as Yup from "yup";
import { useGetNonAttendeeRegistration } from "./dataloader";
import Validation from "shared/form/Validation";
import { useCopies } from "shared/hooks/useCopies";
import { SearchNonAttendeeRegistrationProps } from "./types";

export default function useSearchNonAttendeeService(props: SearchNonAttendeeRegistrationProps) {
  const copies = useCopies();
  const [workEmail, setWorkEmail] = React.useState<string>("");

  const searchErrorHandler = React.useCallback(() => {
    setWorkEmail("");
  }, [setWorkEmail]);

  const { data: nonAttendeeRegistration } = useGetNonAttendeeRegistration({
    registrationId: props.registrationId,
    workEmail,
    viewType: props.viewType,
    successHandler: props.searchSuccessHandler,
    errorHandler: searchErrorHandler,
    ticketFormId: props.ticketFormId
  });

  const initialValues = React.useMemo(
    () => ({
      workEmail: ""
    }),
    []
  );

  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      workEmail: Validation.emailValidation({ copies, required: true })
    });
  }, [copies]);

  const submitHandler = React.useCallback(values => {
    setWorkEmail(values.workEmail);
  }, []);

  return {
    nonAttendeeRegistration,
    initialValues,
    validationSchema,
    submitHandler
  };
}
